import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Button, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { addFileNote } from "../../actions";

interface Props {
    customerId: string;
    ohCaseId: string;
}

export const AddFileNoteButton: React.FunctionComponent<Props> = (props: Props) => {

    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [notes, setNotes] = React.useState<string>(null);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const onOpen = () => setIsModalOpen(true);

    const resetState = () => {
        setNotes(null);
        setSubmitted(false);
        setIsModalOpen(false);
    };

    const onCancel = () => resetState();

    const onNotesChange = (newComments: string) => setNotes(newComments);

    const onAdd = () => {
        setSubmitted(true);
        if (!notes) {
            return;
        }

        dispatch(addFileNote(props.customerId, props.ohCaseId, { notes }));
        setIsModalOpen(false);
        resetState();
    };

    return (
        <>
            <Modal open={isModalOpen}>
                <Modal.Content>
                    <Form>
                        <Input.Textarea
                            required
                            value={notes}
                            showErrors={submitted}
                            label="Notes"
                            onChange={onNotesChange}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={onCancel} />
                    <Button content="Submit" onClick={onAdd} />
                </Modal.Actions>
            </Modal>
            <Button icon="add" content="Add File Note" onClick={onOpen} />
        </>
    );
};
